export const user = ({ user: { user: currentUser } }) => currentUser;
export const allTeams = ({ team: { teams } }) => teams;
export const team = ({ team: { teams = [] }, user: { user: currentUser } }) => {
  if (teams && teams.length) {
    return teams?.find((t) => t.owner === currentUser.uid) || teams[0];
  }

  return null;
};
